import React, { useState } from 'react';
import { AdminListWrapper, TableCell } from 'components/Hospital/PaginationForms';
import moment from 'moment';
import { calculateAge } from 'utils/calculateAge';
import { formattedTime } from 'utils/calculateTime';
import { changeMobileForm } from 'utils/changeMobileForm';
import ProcessCheckBar from 'components/Hospital/ProcessCheckBar';
import GenderMan from 'assets/Icons/Gender/GenderMan';
import GenderWoman from 'assets/Icons/Gender/GenderWoman';
import { adminDiagnosisListWidth } from 'constants/pagination';
import { DiagnosisListpaginationTableProps } from 'models/Hospital/paginationTypes';
import { getWidthRation } from 'utils/calculateWdith';
import BasicButton from 'components/Buttons/BasicButton';
import { ModalBackground, ModalFooter, ModalLayout, ModalTitle } from 'components/Modal/ModalForms';
import styled from 'styled-components';
import { BackgroundColor, TextColor } from 'styles/Global/colorSemantic';
import { IDDiagnosis } from 'models/DCK/basicInterface';
import Flag from 'assets/Icons/Common/Flag';

const AdminDiagnosisListPaginationTable = ({ currentData }: DiagnosisListpaginationTableProps) => {
    const [selectedDiagnosis, setSelectedDiagnosis] = useState<IDDiagnosis | null>(null);

    const handleRowClick = (diagnosis: IDDiagnosis) => {
        setSelectedDiagnosis(diagnosis);
    };

    const handleCloseModal = () => {
        setSelectedDiagnosis(null);
    };

    const copyTextToClipboard = (value?: string) => {
        if (!value) return;
        const tryClipboardApi = async () => {
            try {
                if (typeof navigator !== 'undefined' && navigator.clipboard) {
                    await navigator.clipboard.writeText(value);
                    return true;
                }
            } catch (error) {
                return false;
            }
            return false;
        };

        const fallbackCopy = () => {
            if (typeof document === 'undefined') return;
            const textArea = document.createElement('textarea');
            textArea.value = value;
            textArea.style.position = 'fixed';
            textArea.style.top = '-1000px';
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            try {
                document.execCommand('copy');
            } finally {
                document.body.removeChild(textArea);
            }
        };

        tryClipboardApi().then((success) => {
            if (!success) {
                fallbackCopy();
            }
        });
    };
    return (
        <>
            {currentData?.map((item, idx) => {
                const { birthDate } = calculateAge(item.patientIdentityNumber);
                return (
                    // <AdminListWrapper key={idx} onClick={() => navigate(pagePaths.viewDetaildiagnosis, { state: item })}>
                    <AdminListWrapper key={idx} onClick={() => handleRowClick(item)}>
                        <TableCell $width={getWidthRation(adminDiagnosisListWidth[0])} $type='hospitalName'>
                            <HospitalInfo>
                                <span>{item.hospitalName}</span>
                                {item.deviceKey && (
                                    <DeviceKeyIcon aria-label='device-key'>
                                        <Flag />
                                    </DeviceKeyIcon>
                                )}
                            </HospitalInfo>
                        </TableCell>
                        <TableCell $width={getWidthRation(adminDiagnosisListWidth[1])} $type='name'>
                            {item.patientName + ' '}
                            {item.patientGender === 'male' ? <GenderMan /> : <GenderWoman />}
                        </TableCell>
                        <TableCell $width={getWidthRation(adminDiagnosisListWidth[2])}>{moment(birthDate, 'YYYYMMDD').format('YYYY/MM/DD')}</TableCell>
                        <TableCell $width={getWidthRation(adminDiagnosisListWidth[3])} $type='gradeName'>
                            {item.gradeName}
                        </TableCell>
                        <TableCell $width={getWidthRation(adminDiagnosisListWidth[4])}>{changeMobileForm(item.patientMobile)}</TableCell>
                        <TableCell $width={getWidthRation(adminDiagnosisListWidth[5])}>{formattedTime(item.diagnosisDateTime)}</TableCell>
                        <TableCell $width={getWidthRation(adminDiagnosisListWidth[6])}>{item.doctorName}</TableCell>
                        {/* <TableCell cellType='processBarCell' $width={getWidthRation(adminDiagnosisListWidth[7])} onClick={() => navigate(pagePaths.viewDetaildiagnosis, { state: item })}> */}
                        <TableCell cellType='processBarCell' $width={getWidthRation(adminDiagnosisListWidth[7])}>
                            <ProcessCheckBar diagnosisInfo={item} $height='40px' />
                        </TableCell>
                    </AdminListWrapper>
                );
            })}
            {selectedDiagnosis && (
                <ModalBackground>
                    <ModalLayout $width='620px' $gap='24px'>
                        <ModalTitle>추가 정보</ModalTitle>
                        <DeviceVoucherList>
                            <DeviceVoucherRow>
                                <DeviceVoucherLabel>deviceKey</DeviceVoucherLabel>
                                <DeviceVoucherValue
                                    type='button'
                                    disabled={!selectedDiagnosis.deviceKey}
                                    onClick={() => copyTextToClipboard(selectedDiagnosis.deviceKey)}
                                >
                                    {selectedDiagnosis.deviceKey || '-'}
                                </DeviceVoucherValue>
                            </DeviceVoucherRow>
                            <DeviceVoucherRow>
                                <DeviceVoucherLabel>voucherCode</DeviceVoucherLabel>
                                <DeviceVoucherValue
                                    type='button'
                                    disabled={!selectedDiagnosis.voucherCode}
                                    onClick={() => copyTextToClipboard(selectedDiagnosis.voucherCode)}
                                >
                                    {selectedDiagnosis.voucherCode || '-'}
                                </DeviceVoucherValue>
                            </DeviceVoucherRow>
                        </DeviceVoucherList>
                        <ModalFooter>
                            <BasicButton $width='200px' $height='44px' $type='fill' onClick={handleCloseModal}>
                                확인
                            </BasicButton>
                        </ModalFooter>
                    </ModalLayout>
                </ModalBackground>
            )}
        </>
    );
};

export default AdminDiagnosisListPaginationTable;

const DeviceVoucherList = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 12px;
`;

const DeviceVoucherRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 14px 16px;
    border-radius: 8px;
    background-color: ${BackgroundColor.color_background_light};
`;

const DeviceVoucherLabel = styled.span`
    color: ${TextColor.color_text_light};
`;

const DeviceVoucherValue = styled.button`
    display: inline-flex;
    justify-content: flex-end;
    color: ${TextColor.color_text_normal};
    font-weight: 600;
    word-break: break-all;
    text-align: right;
    border: none;
    background: transparent;
    cursor: pointer;
    padding: 0;
    min-width: 0;
    &:disabled {
        cursor: default;
    }
`;

const HospitalInfo = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
`;

const DeviceKeyIcon = styled.span`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    & > svg {
        width: 18px;
        height: 18px;
    }
`;
